export const PROSPECT_TYPES = "Prospect Types";
export const MEMBERSHIP_TYPES = "Membership Types";
export const FILTER_BY_OPTIONS = [PROSPECT_TYPES, MEMBERSHIP_TYPES];
